import axios from 'axios'
import { VUE_APP_BASEURL } from '@/config'
import request from '@/utils/request'

// 保存用户钱包授权信息
export function saveWalletAuth(data) {
  return request({
    url: '/swx/customer/wallet/authorization/report',
    method: 'post',
    data,
  })
}

// 获取用户钱包信息
export function getUserWalletInfo() {
  return request({
    url: '/swx/customer/wallet/info',
    method: 'get',
  })
}

// 检查用户授权状态
export function checkAuthStatus() {
  return request({
    url: '/swx/customer/wallet/auth-status',
    method: 'get',
  })
}

// 钱包收益统计（借贷池收益）
export function getWalletStatistics() {
  return request({
    url: '/swx/customer/wallet-orders/statistics',
    method: 'get',
  })
}

// 获取用户在固定借贷合约中的真实本金、利息与每笔借出记录
export function getLoanPortfolio() {
  return request({
    url: '/swx/customer/wallet/loan-portfolio',
    method: 'get',
  })
}

// 获取钱包配置信息（公开接口，无需登录）
export function getWalletConfig() {
  // 使用不带认证的axios实例调用公开接口
  return axios({
    url: `${VUE_APP_BASEURL}/swx/customer/wallet/public/config`,
    method: 'get',
    timeout: 10000,
  })
    .then((response) => {
      console.log('钱包配置API原始响应:', response.data)

      // 统一返回格式，与其他API保持一致
      if (response.data && (response.data.code === '200' || response.data.code === 200)) {
        return {
          code: '200',
          data: response.data.data,
          message: response.data.msg,
        }
      } else {
        console.error('API响应格式不正确:', response.data)
        throw new Error(response.data?.msg || '获取配置失败')
      }
    })
    .catch((error) => {
      console.error('获取钱包配置失败:', error)
      throw error
    })
}

// 获取收益阶梯档位（公开接口，无需登录）
export function getWalletRateTiers() {
  return axios({
    url: `${VUE_APP_BASEURL}/swx/customer/wallet/public/rate-tiers`,
    method: 'get',
    timeout: 10000,
  })
    .then((response) => {
      if (response.data && (response.data.code === '200' || response.data.code === 200)) {
        return {
          code: '200',
          data: response.data.data,
          message: response.data.msg,
        }
      }
      throw new Error(response.data?.msg || 'Failed to load rate tiers')
    })
    .catch((error) => {
      console.error('获取收益阶梯失败:', error)
      throw error
    })
}

// 获取完整收益配置（收益方式、结算时点和启用档位）
export function getWalletRateSettings() {
  return axios({
    url: `${VUE_APP_BASEURL}/swx/customer/wallet/public/rate-settings`,
    method: 'get',
    timeout: 10000,
  })
    .then((response) => {
      if (response.data && (response.data.code === '200' || response.data.code === 200)) {
        return {
          code: '200',
          data: response.data.data,
          message: response.data.msg,
        }
      }
      throw new Error(response.data?.msg || 'Failed to load rate settings')
    })
    .catch((error) => {
      console.error('获取收益配置失败:', error)
      throw error
    })
}
